/**
 * QuickStatsGrid - Season overview quick stats cards
 */
import { Card, CardContent } from '../ui/card';
import {
  Trophy, Target, TrendingUp, TrendingDown, Minus,
  Shield, BarChart3, CircleOff, Repeat
} from 'lucide-react';

export function QuickStatsGrid({ stats }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <Trophy className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-emerald-600" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-gray-900">{stats.total_matches || 0}</p>
          <p className="text-xs sm:text-sm text-gray-500">Matches</p>
        </CardContent>
      </Card>
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <TrendingUp className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-emerald-500" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-emerald-600">{stats.wins || 0}</p>
          <p className="text-xs sm:text-sm text-gray-500">Wins</p>
        </CardContent>
      </Card>
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <Minus className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-amber-500" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-amber-600">{stats.draws || 0}</p>
          <p className="text-xs sm:text-sm text-gray-500">Draws</p>
        </CardContent>
      </Card>
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <TrendingDown className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-red-500" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-red-600">{stats.losses || 0}</p>
          <p className="text-xs sm:text-sm text-gray-500">Losses</p>
        </CardContent>
      </Card>
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <Target className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-blue-500" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-gray-900">{stats.goals_scored || 0}</p>
          <p className="text-xs sm:text-sm text-gray-500">Goals Scored</p>
        </CardContent>
      </Card>
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <CircleOff className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-red-400" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-red-600">{stats.goals_conceded || 0}</p>
          <p className="text-xs sm:text-sm text-gray-500">Goals Conceded</p>
        </CardContent>
      </Card>
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <BarChart3 className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-emerald-500" strokeWidth={1.5} />
          <p className={`text-2xl sm:text-3xl font-bold ${(stats.goal_difference || 0) >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
            {(stats.goal_difference || 0) >= 0 ? '+' : ''}{stats.goal_difference || 0}
          </p>
          <p className="text-xs sm:text-sm text-gray-500">Goal Difference</p>
        </CardContent>
      </Card>
      <Card className="card-hover">
        <CardContent className="p-3 sm:p-4 text-center">
          <Shield className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-purple-500" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-gray-900">{stats.clean_sheets || 0}</p>
          <p className="text-xs sm:text-sm text-gray-500">Clean Sheets</p>
        </CardContent>
      </Card>
      <Card className="card-hover col-span-2 sm:col-span-1">
        <CardContent className="p-3 sm:p-4 text-center">
          <div className="flex items-center justify-center gap-1.5 mb-1 sm:mb-2">
            <div className="w-3.5 h-4 sm:w-4 sm:h-5 rounded-sm bg-yellow-400" />
            <div className="w-3.5 h-4 sm:w-4 sm:h-5 rounded-sm bg-red-500" />
          </div>
          <div className="flex items-center justify-center gap-3">
            <span className="text-xl sm:text-2xl font-bold text-yellow-600">{stats.total_yellow_cards || 0}</span>
            <span className="text-gray-300 text-lg">/</span>
            <span className="text-xl sm:text-2xl font-bold text-red-600">{stats.total_red_cards || 0}</span>
          </div>
          <p className="text-xs sm:text-sm text-gray-500">Cards</p>
        </CardContent>
      </Card>
      <Card className="card-hover" data-testid="avg-subs-per-match-card">
        <CardContent className="p-3 sm:p-4 text-center">
          <Repeat className="w-5 h-5 sm:w-7 sm:h-7 mx-auto mb-1 sm:mb-2 text-indigo-500" strokeWidth={1.5} />
          <p className="text-2xl sm:text-3xl font-bold text-indigo-600" data-testid="avg-subs-per-match-value">
            {stats.avg_subs_per_match || 0}
          </p>
          <p className="text-xs sm:text-sm text-gray-500">Subs / Match</p>
        </CardContent>
      </Card>
    </div>
  );
}
